export const CONFIGURATION = {
  signup: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:2dadaa4a-6dae-443c-80a2-583e65574df8",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_HmBXLVzT3",
    AWS_COGNITO_CLIENT_ID: "fndo3is091ls0k8tmlrf7n629",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-signup-api",
    AWS_API_URL: "https://1tznyrlxci.execute-api.us-east-1.amazonaws.com/signup/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "744aef9a7ff24db0b7ebe2d242700951",
    RESPONSUM_API: "signup",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "f"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  deleteme: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:220c77eb-71b7-42b2-bd55-6f1d6d5f097a",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_P3d0NP7b1",
    AWS_COGNITO_CLIENT_ID: "5m28booktktp75h48ap7ihr90c",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-deleteme-api",
    AWS_API_URL: "https://xiosyriixa.execute-api.us-east-1.amazonaws.com/deleteme/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "cec78f328bfe46a69ad92d85fb679be1",
    RESPONSUM_API: "deleteme",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum-test",
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  development: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:9e31a7fc-b4b5-41e2-94ee-71ee45f254a4",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_gk3meYvJR",
    AWS_COGNITO_CLIENT_ID: "2k3ucsgj45qk6ms1sfufp156h8",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-development-api",
    AWS_API_URL: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "cdc072fd22904b16a9aa62850ff2f3fc",
    RESPONSUM_API: "development",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum-test",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  qa: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:ea449b8b-a0e5-4c4e-bb3b-d95905787ac1",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_22pqC0XLo",
    AWS_COGNITO_CLIENT_ID: "jch5gtanl6c714n1rdtlp1mh7",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-qa-api",
    AWS_API_URL: "https://sq1kcs4rw1.execute-api.us-east-1.amazonaws.com/qa/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "bac7fb7d221b402f94651060fc15c16b",
    RESPONSUM_API: "qa",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum-test",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  test: {
    AWS_PINPOINT_APP_ID: "bla"
  },
  vlbtexas: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:9480d2bd-3fca-4973-bf45-0198b7919d46",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_Rjk6YJoRB",
    AWS_COGNITO_CLIENT_ID: "56s8m2a58tcuet3i60kaqv71oc",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-vlbtexas-api",
    AWS_API_URL: "https://ag5d7tnpj5.execute-api.us-east-1.amazonaws.com/vlbtexas/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "ba26e9834dc4401dbe2cbaa262df34af",
    RESPONSUM_API: "vlbtexas",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  bonusdrive: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:8b792c79-7855-4081-8b86-38b353c82448",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_aSKE1TiJi",
    AWS_COGNITO_CLIENT_ID: "1ovpp6qg56jo44qt0opqqskqbk",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-bonusdrive-api",
    AWS_API_URL: "https://8ie0m1yle7.execute-api.us-east-1.amazonaws.com/bonusdrive/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "9a034f2f501c4e2db2d04d8ed5d6629e",
    RESPONSUM_API: "bonusdrive",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: true,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  demo: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:bfe2b3ae-dbc1-442a-928a-71336fc6e07a",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_Wm9L4QfNT",
    AWS_COGNITO_CLIENT_ID: "6be15mdcmqmeekhn8t1k3ldpkk",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-f-demo-api",
    AWS_API_URL: "https://mkffhrtrl3.execute-api.us-east-1.amazonaws.com/demo/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "88cc753b4a044e96bd9e7c6b4c51f74e",
    RESPONSUM_API: "demo",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "f"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum-test",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  warstic: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:7664caa4-b145-4b51-ad51-af915dc4fe2a",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_wXyjfqikL",
    AWS_COGNITO_CLIENT_ID: "6jd9siouujkq5lvg4sif34fkgp",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-warstic-api",
    AWS_API_URL: "https://tmza9airo9.execute-api.us-east-1.amazonaws.com/warstic/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "63da3597e66f4710837c4ed46f84dce4",
    RESPONSUM_API: "warstic",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum-test",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  dickeys: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:ca6d6f87-700b-4f81-b52b-ae9103989972",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_2hQ06zn98",
    AWS_COGNITO_CLIENT_ID: "6cldguffcp72eo18v87dj9k7qi",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-dickeys-api",
    AWS_API_URL: "https://1d82rdzom7.execute-api.us-east-1.amazonaws.com/dickeys/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "602c771293394685b4c0e18134ce2dc5",
    RESPONSUM_API: "dickeys",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  iolap: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:8f060ce5-1e07-497e-81d2-f6f80208b2be",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_rMm0BqmGD",
    AWS_COGNITO_CLIENT_ID: "3usjbpdbgjl4a579v7lqt3ath7",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-iolap-api",
    AWS_API_URL: "https://v39tr0rm69.execute-api.us-east-1.amazonaws.com/iolap/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "a982f00e7e6e48839da031394345d59b",
    RESPONSUM_API: "iolap",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  mkruzic: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:1e7a72ed-cd31-4aa2-92d8-78a96ff64690",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_lZebKQbVf",
    AWS_COGNITO_CLIENT_ID: "7mf31nem6n6sqpl90hfp690sea",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-mkruzic-api",
    AWS_API_URL: "https://qkyxvrmhih.execute-api.us-east-1.amazonaws.com/mkruzic/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "0ec87333f75b4756b425c088fe7bd0bf",
    RESPONSUM_API: "mkruzic",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  develop: {
    AWS_REGION: process.env.REACT_APP_AWS_REGION,
    AWS_COGNITO_IDENTITY_POOL_ID: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
    AWS_COGNITO_USER_POOL_ID: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
    AWS_COGNITO_CLIENT_ID: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
    AWS_API_SERVICE: process.env.REACT_APP_AWS_API_SERVICE,
    AWS_API_NAME: process.env.REACT_APP_AWS_API_NAME,
    AWS_API_URL: process.env.REACT_APP_AWS_API_URL,
    RESPONSUM_API: process.env.REACT_APP_RESPONSUM_API,
    FAQ_BUCKET: process.env.REACT_APP_FAQ_BUCKET,
    RESPONSUM_API_VERSION: process.env.REACT_APP_RESPONSUM_API_VERSION ? parseInt(process.env.REACT_APP_RESPONSUM_API_VERSION) : undefined,
    RESPONSUM_API_RESOURCE_TYPE: process.env.REACT_APP_RESPONSUM_API_RESOURCE_TYPE ? JSON.parse(process.env.REACT_APP_RESPONSUM_API_RESOURCE_TYPE) : undefined,
    CHARGEBEE_SITE: process.env.REACT_APP_CHARGEBEE_SITE,
    SIGNUP_DISSABLED: process.env.REACT_APP_SIGNUP_DISSABLED === "false" ? false : true,
    SQS_UPLOAD_QUEUE: process.env.REACT_APP_SQS_UPLOAD_QUEUE,
    SQS_UTTERANCE_CLUSTER_DATA: process.env.REACT_APP_SQS_UTTERANCE_CLUSTER_DATA
  },
  nea: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:150dd854-2c92-4603-81d3-24e9eaf0ef7c",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_i6F7b7Zdm",
    AWS_COGNITO_CLIENT_ID: "3k3jorgume34ermhcn65i4geek",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-nea-api",
    AWS_API_URL: "https://1a13ps5cl8.execute-api.us-east-1.amazonaws.com/nea/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "191c8ccd2f9947f6b7ecd29c611b9b00",
    RESPONSUM_API: "nea",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  tpoljak: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:a0b7c19b-976b-4846-a951-0f64e7c4074e",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_ntbOvnwGY",
    AWS_COGNITO_CLIENT_ID: "5p8lv7d2oh47a9k819s3nledr3",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-tpoljak-api",
    AWS_API_URL: "https://gmsipqdi21.execute-api.us-east-1.amazonaws.com/tpoljak/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "1ee5ec25d08c432499c20b97b96c6235",
    RESPONSUM_API: "tpoljak",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: false,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  texas: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:cda1f2a8-6db8-4e42-9767-793488e8ec0f",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_xM4HRetJv",
    AWS_COGNITO_CLIENT_ID: "3ojddegcejf67cvlga017nbgh5",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-texas-api",
    AWS_API_URL: "https://06nnu0ps77.execute-api.us-east-1.amazonaws.com/texas/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "8102ca6f766a4552aff0b9773c1557d3",
    RESPONSUM_API: "texas",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: true,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  lucia: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:14323ab2-1468-494a-b643-b59e2d1864f8",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_wP99JXnIr",
    AWS_COGNITO_CLIENT_ID: "grq45d8h20q1hj914vaukb03i",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-lucia-api",
    AWS_API_URL: "https://74wth51qle.execute-api.us-east-1.amazonaws.com/lucia/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "ec312d9df4fa4ac1abd99a65b28568c8",
    RESPONSUM_API: "lucia",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: true,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  has: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:c20ec371-a55e-4a1c-9c5a-45817181c53b",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_TJryoG6Pz",
    AWS_COGNITO_CLIENT_ID: "686q1goa7f4sct0kv2dtf6777p",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-has-api",
    AWS_API_URL: "https://ils1nbcjoa.execute-api.us-east-1.amazonaws.com/has/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "93a1ec75a6224cae9e815183273c0c72",
    RESPONSUM_API: "has",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: true,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  },
  bonusdrivecs: {
    AWS_REGION: "us-east-1",
    AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:ac07b988-c40c-4ac2-89e2-b41a320c1827",
    AWS_COGNITO_USER_POOL_ID: "us-east-1_85sInD75S",
    AWS_COGNITO_CLIENT_ID: "4b0uoq0p15eutiec7eje7uri48",
    AWS_API_SERVICE: "gateway",
    AWS_API_NAME: "apig-ue1-e-bonusdrivecs-api",
    AWS_API_URL: "https://5pq7wuw3lb.execute-api.us-east-1.amazonaws.com/bonusdrivecs/",
    AWS_API_URL_PUBLIC: "https://42e7exbe0l.execute-api.us-east-1.amazonaws.com/development/",
    AWS_PINPOINT_APP_ID: "b8a56d5ad4a44da5b83a5fd7310f0cbd",
    RESPONSUM_API: "bonusdrivecs",
    RESPONSUM_API_VERSION: 2,
    RESPONSUM_API_RESOURCE_TYPE: {
      SHARED: "s",
      PRIVATE: "e"
    },
    SOLR_INSTANCE: "https://solr.responsum.ai:8983/solr",
    CHARGEBEE_SITE: "responsum",
    SIGNUP_DISSABLED: true,
    SQS_UPLOAD_QUEUE: "https://sqs.us-east-1.amazonaws.com/467814946077",
    SQS_UTTERANCE_CLUSTER_DATA:
      "https://sqs.us-east-1.amazonaws.com/467814946077/sqs-ue1-s-shared-clustering_analysis_queue"
  }
};
